import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import type {SwiperOptions} from 'swiper/types';
import {HeroEntry} from '../../custom-stuff/etc/types';

@Component({
    selector: 'app-hero-swiper',
    templateUrl: './hero-swiper.component.html',
    styleUrls: ['./hero-swiper.component.scss'],
    standalone: false
})
export class HeroSwiperComponent implements OnInit, AfterViewInit {
	@Input() entryRegistation: BehaviorSubject<any>; 
	@Input() entryClicked: BehaviorSubject<any>; 
  @ViewChild("swiper", { static: false }) swiperEl: ElementRef;

	heroCarousel: HeroEntry[] = [];

  config: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 50,
    loop: true,
    autoplay: { delay: 5000, disableOnInteraction: true },
  };

  constructor() { }

  ngOnInit(): void {
		this.entryRegistation.subscribe((res: HeroEntry) => {
			if (!res.image) return;
			this.heroCarousel.push(res)
		});
  }

  ngAfterViewInit(): void {
    if (this.swiperEl?.nativeElement && !this.swiperEl.nativeElement.swiper) {
      Object.assign(this.swiperEl.nativeElement, this.config);
      this.swiperEl.nativeElement.initialize();
    }
  }

	toggleEntry(entry: HeroEntry) {
		console.log(entry);
		this.entryClicked.next({accordionName: entry.accordionName, index: entry.index});

	}


  slideNext(event: any): void {
		event.stopPropagation();
    this.swiperEl?.nativeElement?.swiper?.slideNext();
  }

}
